/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/chevron-left
 */
import { default as DefaultIcon } from '~icons/lucide/chevron-left';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ChevronLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
